// Vendor Libraries
import React from 'react';
import PropTypes from 'prop-types';
import {concat, filter, get, map, orderBy, startCase} from 'lodash';

// Components
import Thumbnail from '../core/thumbnail';

// Styles
import './movies-and-programs-thumbnails.scss';

function MoviesAndProgramsThumbnails(props) {
    const {searchData} = props;
    const isEpisodeContentType = get(searchData, '0.echostarContentType') === 'SRE';
    const images = orderBy(
        filter(
            filter(concat(get(searchData, '0.images', []), get(searchData, '0.seasonImages', [])), 'url'),
            ({category}) => !isEpisodeContentType || (category !== 'Franchise' && category !== 'TitleArt')
        ),
        'category'
    );

    return images.length ? (
        <div className="movies-and-programs-thumbnails">
            {map(images, ({amsGalleryId, category, imageHeight, imageWidth, url}) => (
                <Thumbnail
                    className="movies-and-programs-thumbnails--thumbnail"
                    height={imageHeight}
                    key={amsGalleryId}
                    label={startCase(category)}
                    src={url}
                    width={imageWidth}
                />
            ))}
        </div>
    ) : null;
}

MoviesAndProgramsThumbnails.propTypes = {
    searchData: PropTypes.array.isRequired,
};

export default MoviesAndProgramsThumbnails;
